import { MonthInputController } from '@membership-entry/components/MonthInput.tsx';

interface IMemberEmploymentProps {
    name: string;
    label?: string;
    minDate?: any;
    maxDate?: any;
    control: any;
    rules?: any;
    endOfMonth?: boolean;

    [x: string]: any;
}

export const EmploymentDateInputForm = ({ name, label, control, rules, minDate, maxDate, endOfMonth }: IMemberEmploymentProps) => {
    //TODO: CHANGE CALENDR
    return (
        <div className='form-group row'>
            <label
                htmlFor={name}
                className='col-md-3 col-form-label label-sm label-required'
            >
                {label || 'Från och med'}
            </label>
            <div className='col-md-9'>
                <MonthInputController
                    control={control}
                    rules={rules}
                    minDate={minDate}
                    maxDate={maxDate}
                    id={name}
                    name={name}
                    endOfMonth={endOfMonth}
                />
                <ul className='form-text text-muted font-size-sm mb-0'>
                    <li>Du kan inte välja innevarande eller tidigare månader.</li>
                </ul>
            </div>
        </div>
    );
};

interface IEmploymentSalaryInputProps {
    name: string;
    defaultValue?: any;
    register: any;
}

export const EmploymentSalaryInputForm = ({ name, register }: IEmploymentSalaryInputProps) => {
    return (
        <>
            <h4 className='mt-5'>Inkomst</h4>
            <div className='form-group row'>
                <label
                    htmlFor={name}
                    className='col-md-3 col-form-label label-sm label-required'
                >
                    Inkomst per månad före skatt
                </label>
                <div className='col-md-9'>
                    <input
                        type='number'
                        id={name}
                        className='form-control highlight-mask'
                        min='0'
                        {...register}
                        autoComplete={name}
                    />
                    <ul className='form-text text-muted font-size-sm mb-0'>
                        <li>Fyll i din genomsnittliga månadslön inkl. alla tillägg förutom övertidstillägg.</li>
                        <li>Har du timlön fyller du i vad du sammanlagt tjänar under en genomsnittlig månad.</li>
                        <li>Ange bruttolönen – alltså din lön före skatt.</li>
                        <li>Om du är arbetslös, ange hur mycket du får från a-kassan.</li>
                    </ul>
                </div>
            </div>
        </>
    );
};
